// extracted by mini-css-extract-plugin
module.exports = {"inputTags":"style_inputTags__2GQkc","borderInput":"style_borderInput__3ob5s","inputTags_input":"style_inputTags_input__50K5t","tag":"style_tag__1vxsU"};